<template lang="html">
  <section id="syllable-slider">
     <small class="d-block">{{hebrew ? 'מספר הברות' : 'Number of syllables'}}</small>
     <div class="pb-4">
        <vue-slider
        v-model="value"
        :dotSize="16"
        :contained="true"
        :enable-cross="true"
        :tooltip="'none'"
        :dragOnClick="true"  
        :height="9" 
        :min="1"
        :max="7"
        :marks="true"
        :data="data"
        class="mb-2"
        @drag-end="setSylValue(value)">
        </vue-slider>        
      </div>
  </section>
</template>

<script lang="js">
  import {Actions} from '@/store/stateChanges'
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/default.css'
  export default  {
    name: 'SyllableSlider',
    components: {
      VueSlider,
    },
    props: [],
    data() {
      return {
        value: [this.$store.state.preSubmissionOptions.minSyllable, this.$store.state.preSubmissionOptions.maxSyllable],
        data: ['1', '2', '3', '4', '5', '6', '7+']
      }
    },
    methods: {
      setSylValue(value) {
        this.$store.commit('SET_MIN_SYL', value[0])
        this.$store.commit('SET_MAX_SYL',  value[1])
        this.$store.dispatch(Actions.RUN_CHARUZIT) 
      }
    },
    computed: {
      hebrew () {
        return this.$settings.hebrew
      }
    }    
  }
</script>